module.exports = __webpack_public_path__ + "media/src/fonts/GillSansProCyrillic-Medium-6a85d8728c958fe0b0dd3683fee01df5.woff2";